interface BrgColorKeyProps {
  colorMap: Map<number, { name: string; color: string }>;
}

// Same layout and typography as the Calendar page "BRG Color Key" section
export function BrgColorKey({ colorMap }: BrgColorKeyProps) {
  const colors = Array.from(colorMap.values()).sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div
      data-testid="brg-color-key"
      style={{
        marginTop: '16px',
        padding: '16px',
        backgroundColor: '#f3f4f6',
        borderRadius: '6px',
        border: '1px solid #e5e7eb',
      }}
    >
      <h3 style={{ margin: '0 0 12px 0', fontSize: '12px', fontWeight: 'bold', color: '#111827' }}>
        BRG Color Legend
      </h3>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '12px',
        }}
      >
        {colors.map((item) => (
          <div key={item.name} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              style={{
                width: '12px',
                height: '12px',
                borderRadius: '2px',
                backgroundColor: item.color,
                flexShrink: 0,
              }}
            />
            <span style={{ fontSize: '12px', color: '#374151' }}>{item.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
